import ModalMultiple from "./ModalMultiple.jsx";

export default ModalMultiple;